import ImageUpload from "../../formability/organization_settings/models/imageUpload";
import IAccount from "../interfaces/account";
import { ICapable } from "../interfaces/capableInterfaces";
import Capable from "../mixins/capable";
import Share from "./share";
import UntrackedModel from "./untracked/untrackedModel";
import IRepo from "~/interfaces/repo";
import AccountRelationUserProvider from "~/providers/accountRelationUserProvider";
import Repo from "~/state/modules/repo";

export default class User extends Capable(UntrackedModel) implements ICapable, IAccount {
  id: string;
  first_name: string;
  last_name: string;
  email: string;
  activation_status: number;
  gui_theme: string;
  image_uploads: ImageUpload[] = [];
  selected_organization_id: string;
  share: Share;
  time_zone: string = "America/New_York";
  group_ids: string[];
  // Used to check permissions in Analyst Dashboard
  can_view_data_tables_reporting_and_submissions?: boolean
  is_admin?: boolean
  can_reset_expired: boolean
  expired?: boolean

  static readonly UNSCOPED_ID: string = 'formability'

  static get displayName(): string {
    return 'User';
  }

  get user() {
    return this;
  }

  get avatar(): ImageUpload {
    return this.user.image_uploads.find(img => img.name === 'avatar');
  }

  static repo: IRepo<User, AccountRelationUserProvider> = new Repo<User, AccountRelationUserProvider>(
    'users',
    User,
    {},
    new AccountRelationUserProvider(User, 'user', 'users')
  );
  repo: IRepo<this, AccountRelationUserProvider<this>>;

  static get provider(): AccountRelationUserProvider {
    return this.repo.provider;
  }
}